import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation, Navigate } from 'react-router-dom';
import './App.css';

import Navbar from './Components/Navbar/Navbar';
import Homepage from './Pages/Homepage';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import Footer from './Components/Footer/Footer';
import ExperiencePage from './Pages/ExperiencePage';
import Project from './Components/Project/Project';
import Loading from './Components/Loading/Loading';
import Unknown from './Components/Unknown/Unknown';
import Spotify from './Components/Spotify/Spotify';
import Gallery from './Components/Gallery/Gallery';
import Blogs from './Components/Blogs/Blogs';

const App = () => {
  const location = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const [loading, setLoading] = useState(true);

  setTimeout(() => setLoading(false), 6000);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div>
          <Navbar />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/contact" element={<ContactPage />}></Route>
            <Route path="/experience" element={<ExperiencePage />}></Route>
            <Route path="/projects" element={<Project />}></Route>
            <Route path="/gallery" element={<Gallery />}></Route>
            <Route path="/blogs" element={<Blogs />}></Route>
            <Route path="/unknown" element={<Unknown />}></Route>
            <Route path="/spotify" element={<Spotify />}></Route>
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
          {location.pathname !== '/contact' && <Footer />}
        </div>
      )}
    </>
  );
};

export default App;
